import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PromptModalModule } from 'Angular/features/components/modals/prompt-modal/prompt-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class ChartEditorHeaderModule {
}
ChartEditorHeaderModule.ɵfac = function ChartEditorHeaderModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartEditorHeaderModule)(); };
ChartEditorHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ChartEditorHeaderModule });
ChartEditorHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, IconModule, PromptModalModule, TooltipModule] });
